import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const ICTConsultancyFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How do I know what ICT setup my office or school actually needs?">
                  <p>You don’t need to figure that out yourself. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Assess your needs</span>
                    </li>
                    <li>
                      <span>Understand your users and operations</span>
                    </li>
                    <li>
                      <span>Design a structured system plan</span>
                    </li>
                  </ul>
                  <p>
                    You start with a well-structured ICT plan that is efficient,
                    scalable, and cost-effective.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can you handle everything from start to finish?">
                  <p>Yes. We cover:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Consultancy</span>
                    </li>
                    <li>
                      <span>Procurement</span>
                    </li>
                    <li>
                      <span>Installation</span>
                    </li>
                    <li>
                      <span>Configuration</span>
                    </li>
                    <li>
                      <span>Training</span>
                    </li>
                    <li>
                      <span>Ongoing support</span>
                    </li>
                  </ul>
                  <p>
                    You work with one reliable partner—not multiple vendors.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the system be properly structured or just a collection of devices?">
                  <p>We don’t install random equipment. We design:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Organized system architecture</span>
                    </li>
                    <li>
                      <span>Integrated devices and workflows</span>
                    </li>
                    <li>
                      <span>Clear system structure</span>
                    </li>
                  </ul>
                  <p>
                    You get a fully structured ICT environment where everything
                    works together seamlessly.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the hardware be ready to use immediately after installation?">
                  <p>Yes. All equipment is:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Installed</span>
                    </li>
                    <li>
                      <span>Configured</span>
                    </li>
                    <li>
                      <span>Tested</span>
                    </li>
                  </ul>
                  <p>You receive reliable, ready-to-use systems.</p>
                </FaqCardList>
                <FaqCardList faq="Will the computer lab be functional and suitable for learning and exams?">
                  <p>Yes. We design labs that are:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Organized and safe</span>
                    </li>
                    <li>
                      <span>Easy to manage</span>
                    </li>
                    <li>
                      <span>Suitable for teaching and exams</span>
                    </li>
                  </ul>
                  <p>You get a complete, structured learning environment.</p>
                </FaqCardList>
                <FaqCardList faq="Will our office setup actually improve productivity?">
                  <p>Yes. We create systems that:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Improve workflows</span>
                    </li>
                    <li>
                      <span>Reduce delays</span>
                    </li>
                    <li>
                      <span>Enhance communication</span>
                    </li>
                  </ul>
                  <p>Your office becomes more efficient and productive.</p>
                </FaqCardList>
                <FaqCardList faq="Will the network and internet be stable across all areas?">
                  <p>Yes. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Proper network design</span>
                    </li>
                    <li>
                      <span>Strong Wi-Fi coverage</span>
                    </li>
                    <li>
                      <span>Optimized connectivity</span>
                    </li>
                  </ul>
                  <p>
                    You get fast, stable, and reliable internet throughout your
                    space.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the systems be easy for our staff or students to use?">
                  <p>Yes. We ensure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Simple configurations</span>
                    </li>
                    <li>
                      <span>Logical structure</span>
                    </li>
                    <li>
                      <span>User-friendly setup</span>
                    </li>
                  </ul>
                  <p>Your team works with confidence—not confusion.</p>
                </FaqCardList>
                <FaqCardList faq="How do you protect our systems, data, and assets?">
                  <p>We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>CCTV and surveillance</span>
                    </li>
                    <li>
                      <span>Access control</span>
                    </li>
                    <li>
                      <span>Cybersecurity basics</span>
                    </li>
                    <li>
                      <span>Backup systems</span>
                    </li>
                  </ul>
                  <p>You operate in a secure and protected environment.</p>
                </FaqCardList>
                <FaqCardList faq="Can we access our systems remotely or work from different locations?">
                  <p>Yes. We set up:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Cloud systems</span>
                    </li>
                    <li>
                      <span>Remote access</span>
                    </li>
                    <li>
                      <span>Collaboration tools</span>
                    </li>
                  </ul>
                  <p>Your team can work from anywhere without disruption.</p>
                </FaqCardList>
                <FaqCardList faq="What happens if we lose data or experience system failure?">
                  <p>We plan for that. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Automated backups</span>
                    </li>
                    <li>
                      <span>Recovery systems</span>
                    </li>
                    <li>
                      <span>Power protection</span>
                    </li>
                  </ul>
                  <p>
                    Your operations are protected from data loss and downtime.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the system remain reliable over time?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Maintenance</span>
                    </li>
                    <li>
                      <span>Monitoring</span>
                    </li>
                    <li>
                      <span>Continuous support</span>
                    </li>
                  </ul>
                  <p>Your systems remain stable and reliable long-term.</p>
                </FaqCardList>
                <FaqCardList faq="Can the system grow as our organization grows?">
                  <p>Yes. We design systems that:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Support expansion</span>
                    </li>
                    <li>
                      <span>Add users and devices</span>
                    </li>
                    <li>
                      <span>Scale easily</span>
                    </li>
                  </ul>
                  <p>Your setup grows with you—no need to rebuild later.</p>
                </FaqCardList>
                <FaqCardList faq="What happens if something stops working?">
                  <p>We’ve got you covered. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Troubleshooting</span>
                    </li>
                    <li>
                      <span>Repairs</span>
                    </li>
                    <li>
                      <span>Technical support</span>
                    </li>
                  </ul>
                  <p>
                    You’re never left alone—we ensure continuous performance.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do you supply equipment or only install?">
                  <p>We do both.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Supply reliable equipment</span>
                    </li>
                    <li>
                      <span>Install and configure everything</span>
                    </li>
                  </ul>
                  <p>You receive a complete, ready-to-use solution.</p>
                </FaqCardList>
                <FaqCardList faq="Can you upgrade or fix our existing ICT setup?">
                  <p>Yes. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Audit your current system</span>
                    </li>
                    <li>
                      <span>Fix issues</span>
                    </li>
                    <li>
                      <span>Improve performance</span>
                    </li>
                    <li>
                      <span>Upgrade infrastructure</span>
                    </li>
                  </ul>
                  <p>
                    We transform weak setups into efficient, reliable systems.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if we have a limited budget?">
                  <p>We design based on your budget.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Prioritize essentials</span>
                    </li>
                    <li>
                      <span>Plan phased implementation</span>
                    </li>
                    <li>
                      <span>Optimize costs</span>
                    </li>
                  </ul>
                  <p>
                    You still get a functional and scalable system without
                    overspending.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will our team be trained to use the system properly?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Training sessions</span>
                    </li>
                    <li>
                      <span>Practical guidance</span>
                    </li>
                    <li>
                      <span>Best practices</span>
                    </li>
                  </ul>
                  <p>Your team becomes confident and capable.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to complete a setup?">
                  <p>It depends on the size:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Small setups: a few days</span>
                    </li>
                    <li>
                      <span>Medium: 1–2 weeks</span>
                    </li>
                    <li>
                      <span>Larger setups: longer</span>
                    </li>
                  </ul>
                  <p>Timelines are clearly defined before we start.</p>
                </FaqCardList>
                <FaqCardList faq="Do I need to be involved during the setup process?">
                  <p>Minimal involvement is required. You may:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Approve plans</span>
                    </li>
                    <li>
                      <span>Provide key information</span>
                    </li>
                  </ul>
                  <p>
                    We handle the technical work while keeping you informed.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I clearly understand what I’m getting before the project starts?">
                  <p>Yes. We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Clear system plans</span>
                    </li>
                    <li>
                      <span>Defined scope</span>
                    </li>
                    <li>
                      <span>Transparent recommendations</span>
                    </li>
                  </ul>
                  <p>
                    You move forward with clarity and confidence—no surprises.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other ICT providers?">
                  <p>We don’t just install equipment.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>We design structured systems</span>
                    </li>
                    <li>
                      <span>We focus on long-term reliability</span>
                    </li>
                    <li>
                      <span>We provide ongoing support</span>
                    </li>
                  </ul>
                  <p>You get a dependable ICT partner—not just a technician.</p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Define all requirements</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin setups & installation</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTConsultancyFaqsBody;
